module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section small-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-fill",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "to": "/campaigns/new"
    }
  }, [_vm._v("Nueva")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.campaigns.length == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v("No hay campañas")])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.campaigns), function(camp, idx) {
    return _c('tr', [_c('td', [_c('router-link', {
      staticClass: "text-brand",
      attrs: {
        "to": ("/campaigns/edit/" + (camp._id))
      }
    }, [_c('label', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(camp.name))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearFecha")(camp.fechaCreacion)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearFecha")(camp.fechaInicio)))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label btn-info",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.verSucursales(camp)
        }
      }
    }, [_vm._v("Sucursales")]), _vm._v(" "), (camp.activo) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Activa")]) : _vm._e(), _vm._v(" "), (camp.activo) ? _c('span', {
      staticClass: "label btn-brand",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.finalizarCampaign(camp)
        }
      }
    }, [_vm._v("Finalizar campaña")]) : _vm._e(), _vm._v(" "), (!camp.activo) ? _c('span', [(_vm.yaComenzo(camp.fechaInicio)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n                  Inactiva\n                ")]) : _c('span', [_c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("\n                    Inicia " + _vm._s(_vm._f("fromNow")(camp.fechaInicio)) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "label btn-brand",
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          _vm.cancelarCampaign(camp)
        }
      }
    }, [_vm._v("Cancelar campaña")])])]) : _vm._e()])])
  }))])])])]), _vm._v(" "), _c('div', {
    ref: "modalSucursales",
    staticClass: "modal",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sucursales), function(suc) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4"
    }, [_vm._v("\n                        " + _vm._s(suc.denominacion) + " - " + _vm._s(suc.empresa.razonSocial) + "\n                    ")])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Campañas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Fecha Creacion")]), _vm._v(" "), _c('th', [_vm._v("Fecha Inicio")]), _vm._v(" "), _c('th', [_vm._v("Activa")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Sucursales")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00d0552f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaigns/Campaigns.vue
// module id = 1101
// module chunks = 5